import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './styles/tailadmin/financial-tailwind.css'
import './styles/tailadmin/financial-custom.css'
import './styles/main.css'

createApp(App).use(router).mount('#app')
